import React from 'react';
import { MobileBlurBackdrop } from 'ts/common/components/gallery/screenshot-deterrence/MobileBlur';
import useMobileBlur from 'ts/common/components/gallery/screenshot-deterrence/MobileBlurContext';

// Above both crossfading photo layers (z-index 9 and 10); the controls stack above this
const overlayStyle: React.CSSProperties = {
    position: 'absolute',
    inset: 0,
    zIndex: 10
};

/**
 * Mobile screenshot protection for the legacy AngularJS slideshow, whose photos are CSS
 * backgrounds that can't be copied like a photo, so it blurs whatever paints behind it. The
 * overlay takes the long press; a plain tap still bubbles up to toggle the slideshow controls.
 */
const LegacySlideshowMobileBlur: React.FC = () => {
    const { blur, pressHandlers } = useMobileBlur('lightbox');

    return blur ? (
        <div style={overlayStyle} {...pressHandlers}>
            <MobileBlurBackdrop {...blur} />
        </div>
    ) : null;
};

export default LegacySlideshowMobileBlur;
